import React from "react";
import { useDateConfig } from './contexts/DateConfigContext';

const ConsignmentOver = () => {
  const { currentYear, sale } = useDateConfig();

  return (
    <div>
      <h3>{currentYear} Cochran's Ski Sale Consignment is Closed</h3>
      <p>Thank you for your interest in the {currentYear} Cochran's Ski Sale! Our consignment is now closed and we are getting ready
      for the <a href="https://www.cochranskisale.com">ski sale!</a> The sale is {sale.range} at Camel's Hump Middle School.
      See you there!</p>

      <p>For support please email <a href="mailto:skisale@cochranskiclub.com">skisale@cochranskiclub.com</a></p>
    </div>
  );
};

export default ConsignmentOver;